// Inject the gamzone shared header/footer ONLY when loaded as a portal
// "subpage" (gamzone.co.kr/game_app/.../). At a subdomain root, on local dev,
// on mobile browsers and in a native shell we skip it — exactly as the
// reference games' embed/portalChrome.js does.
//
// In production the real portal serves /shared/gamzone-ui.js|css at its origin
// and this function just loads them. Standalone (localhost, subdomain) there is
// NO header/footer — the game shell panel is the whole UI. To keep this test
// build self-contained we render the same gz-header / gz-footer markup inline
// when on a /game_app/ desktop path, matching the shared module's output.

const GZ_BUSINESS_1 =
  "상호: 스타일 팡 (STYLE PANG)|대표자: 강민정|사업자등록번호: 208-30-92421";
const GZ_BUSINESS_2 =
  "주소: 경기도 김포시 태장로 845, 109동 1401호|전화: +82-10-4689-1343|이메일: admin@gamzone.co.kr";
const PORTAL = "https://gamzone.co.kr";

export function isPortalSubpage(): boolean {
  if (typeof window === "undefined") return false;
  if (window.location.protocol === "file:") return false;
  return window.location.pathname.includes("/game_app/");
}

function isMobileBrowser(): boolean {
  return (
    typeof window !== "undefined" &&
    window.matchMedia("(pointer: coarse)").matches
  );
}

export function setupPortalChrome(): void {
  if (!isPortalSubpage() || isMobileBrowser()) return;
  const body = document.body;
  if (body.dataset.gzChrome === "on") return;
  body.dataset.gzChrome = "on";
  body.classList.add("gz-embedded");
  body.dataset.gzBack = "/main";
  body.dataset.gzBackLabel = "이전";
  body.dataset.gzNoauth = ""; // login lives inside the game

  const header = document.createElement("header");
  header.className = "gz-header";
  header.innerHTML = `
    <div class="gz-left">
      <a class="gz-back" href="${PORTAL}/" aria-label="이전">
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" d="M15 6l-6 6 6 6"/></svg>
      </a>
      <a class="gz-brand" href="${PORTAL}/"><span class="gz-brand-icon">🎮</span> gamzone</a>
    </div>
    <a class="gz-db-logo" href="${PORTAL}/retro/" aria-label="겜존 DB"><span class="gz-db-icon">🕹️</span><span>겜존 <b>DB</b></span></a>`;
  document.body.prepend(header);

  const footer = document.createElement("footer");
  footer.className = "gz-footer";
  const b1 = GZ_BUSINESS_1.split("|").map((s) => `<span>${s}</span>`).join("");
  const b2 = GZ_BUSINESS_2.split("|").map((s) => `<span>${s}</span>`).join("");
  footer.innerHTML = `
    <div class="gz-footer-business">${b1}</div>
    <div class="gz-footer-business">${b2}</div>
    <div class="gz-footer-copy">© 2026 gamzone · <a href="${PORTAL}/about/">소개</a> · <a href="${PORTAL}/guides/">공략실</a> · <a href="${PORTAL}/retro/">레트로</a> · <a href="${PORTAL}/updates/">업데이트</a> · <a href="${PORTAL}/privacy">개인정보처리방침</a> · <a href="${PORTAL}/terms">이용약관</a> · <a href="${PORTAL}/delete-account">계정 삭제</a> · <a href="mailto:admin@gamzone.co.kr">문의</a></div>`;
  document.body.append(footer);

  window.dispatchEvent(new Event("resize"));
}
